export type PhoneCode = {
  code: string;
  iso3: string;
  name: string;
  flag: string;
};

export const PHONE_CODES: PhoneCode[] = [
  { code: "+297", iso3: "ABW", name: "Aruba", flag: "🇦🇼" },
  { code: "+93", iso3: "AFG", name: "Afghanistan", flag: "🇦🇫" },
  { code: "+244", iso3: "AGO", name: "Angola", flag: "🇦🇴" },
  { code: "+1-264", iso3: "AIA", name: "Anguilla", flag: "🇦🇮" },
  { code: "+358", iso3: "ALA", name: "Kepulauan Aland", flag: "🇦🇽" },
  { code: "+355", iso3: "ALB", name: "Albania", flag: "🇦🇱" },
  { code: "+376", iso3: "AND", name: "Andorra", flag: "🇦🇩" },
  { code: "+971", iso3: "ARE", name: "United Arab Emirates", flag: "🇦🇪" },
  { code: "+54", iso3: "ARG", name: "Argentina", flag: "🇦🇷" },
  { code: "+374", iso3: "ARM", name: "Armenia", flag: "🇦🇲" },
  { code: "+1-684", iso3: "ASM", name: "Samoa Amerika", flag: "🇦🇸" },
  { code: "+672", iso3: "ATA", name: "Antartika", flag: "🇦🇶" },
  { code: "+262", iso3: "ATF", name: "Wilayah Selatan Perancis", flag: "🇹🇫" },
  { code: "+1-268", iso3: "ATG", name: "Antigua and Barbuda", flag: "🇦🇬" },
  { code: "+61", iso3: "AUS", name: "Australia", flag: "🇦🇺" },
  { code: "+43", iso3: "AUT", name: "Austria", flag: "🇦🇹" },
  { code: "+994", iso3: "AZE", name: "Azerbaijan", flag: "🇦🇿" },
  { code: "+257", iso3: "BDI", name: "Burundi", flag: "🇧🇮" },
  { code: "+32", iso3: "BEL", name: "Belgium", flag: "🇧🇪" },
  { code: "+229", iso3: "BEN", name: "Benin", flag: "🇧🇯" },
  { code: "+599", iso3: "BES", name: "Belanda Caribbean", flag: "🇧🇶" },
  { code: "+226", iso3: "BFA", name: "Burkina Faso", flag: "🇧🇫" },
  { code: "+880", iso3: "BGD", name: "Bangladesh", flag: "🇧🇩" },
  { code: "+359", iso3: "BGR", name: "Bulgaria", flag: "🇧🇬" },
  { code: "+973", iso3: "BHR", name: "Bahrain", flag: "🇧🇭" },
  { code: "+1-242", iso3: "BHS", name: "Bahamas", flag: "🇧🇸" },
  { code: "+387", iso3: "BIH", name: "Bosnia and Herzegovina", flag: "🇧🇦" },
  { code: "+590", iso3: "BLM", name: "St. Barthelemy", flag: "🇧🇱" },
  { code: "+375", iso3: "BLR", name: "Belarus", flag: "🇧🇾" },
  { code: "+501", iso3: "BLZ", name: "Belize", flag: "🇧🇿" },
  { code: "+1-441", iso3: "BMU", name: "Bermuda", flag: "🇧🇲" },
  { code: "+591", iso3: "BOL", name: "Bolivia (Plurinational State of)", flag: "🇧🇴" },
  { code: "+55", iso3: "BRA", name: "Brazil", flag: "🇧🇷" },
  { code: "+1-246", iso3: "BRB", name: "Barbados", flag: "🇧🇧" },
  { code: "+673", iso3: "BRN", name: "Brunei Darussalam", flag: "🇧🇳" },
  { code: "+975", iso3: "BTN", name: "Bhutan", flag: "🇧🇹" },
  { code: "+47", iso3: "BVT", name: "Pulau Bouvet", flag: "🇧🇻" },
  { code: "+267", iso3: "BWA", name: "Botswana", flag: "🇧🇼" },
  { code: "+236", iso3: "CAF", name: "Central African Republic", flag: "🇨🇫" },
  { code: "+1", iso3: "CAN", name: "Canada", flag: "🇨🇦" },
  { code: "+61", iso3: "CCK", name: "Kepulauan Cocos (Keeling)", flag: "🇨🇨" },
  { code: "+41", iso3: "CHE", name: "Switzerland", flag: "🇨🇭" },
  { code: "+56", iso3: "CHL", name: "Chile", flag: "🇨🇱" },
  { code: "+86", iso3: "CHN", name: "China", flag: "🇨🇳" },
  { code: "+225", iso3: "CIV", name: "Cote d’Ivoire", flag: "🇨🇮" },
  { code: "+237", iso3: "CMR", name: "Cameroon", flag: "🇨🇲" },
  { code: "+243", iso3: "COD", name: "Democratic Republic of the Congo", flag: "🇨🇩" },
  { code: "+242", iso3: "COG", name: "Congo", flag: "🇨🇬" },
  { code: "+682", iso3: "COK", name: "Cook Islands (the) **", flag: "🇨🇰" },
  { code: "+57", iso3: "COL", name: "Colombia", flag: "🇨🇴" },
  { code: "+269", iso3: "COM", name: "Comoros", flag: "🇰🇲" },
  { code: "+238", iso3: "CPV", name: "Cabo Verde", flag: "🇨🇻" },
  { code: "+506", iso3: "CRI", name: "Costa Rica", flag: "🇨🇷" },
  { code: "+53", iso3: "CUB", name: "Cuba", flag: "🇨🇺" },
  { code: "+599", iso3: "CUW", name: "Curacao", flag: "🇨🇼" },
  { code: "+61", iso3: "CXR", name: "Pulau Krismas", flag: "🇨🇽" },
  { code: "+1-345", iso3: "CYM", name: "Kepulauan Cayman", flag: "🇰🇾" },
  { code: "+357", iso3: "CYP", name: "Cyprus", flag: "🇨🇾" },
  { code: "+420", iso3: "CZE", name: "Czechia", flag: "🇨🇿" },
  { code: "+49", iso3: "DEU", name: "Germany", flag: "🇩🇪" },
  { code: "+253", iso3: "DJI", name: "Djibouti", flag: "🇩🇯" },
  { code: "+1-767", iso3: "DMA", name: "Dominica", flag: "🇩🇲" },
  { code: "+45", iso3: "DNK", name: "Denmark", flag: "🇩🇰" },
  { code: "+1-809,1-829,1-849", iso3: "DOM", name: "Dominican Republic", flag: "🇩🇴" },
  { code: "+213", iso3: "DZA", name: "Algeria", flag: "🇩🇿" },
  { code: "+593", iso3: "ECU", name: "Ecuador", flag: "🇪🇨" },
  { code: "+20", iso3: "EGY", name: "Egypt", flag: "🇪🇬" },
  { code: "+291", iso3: "ERI", name: "Eritrea", flag: "🇪🇷" },
  { code: "+212", iso3: "ESH", name: "Sahara Barat", flag: "🇪🇭" },
  { code: "+34", iso3: "ESP", name: "Spain", flag: "🇪🇸" },
  { code: "+372", iso3: "EST", name: "Estonia", flag: "🇪🇪" },
  { code: "+251", iso3: "ETH", name: "Ethiopia", flag: "🇪🇹" },
  { code: "+358", iso3: "FIN", name: "Finland", flag: "🇫🇮" },
  { code: "+679", iso3: "FJI", name: "Fiji", flag: "🇫🇯" },
  { code: "+500", iso3: "FLK", name: "Kepulauan Falkland", flag: "🇫🇰" },
  { code: "+33", iso3: "FRA", name: "France", flag: "🇫🇷" },
  { code: "+298", iso3: "FRO", name: "Kepulauan Faroe", flag: "🇫🇴" },
  { code: "+691", iso3: "FSM", name: "Micronesia (Federated States of)", flag: "🇫🇲" },
  { code: "+241", iso3: "GAB", name: "Gabon", flag: "🇬🇦" },
  { code: "+44", iso3: "GBR", name: "United Kingdom of Great Britain and Northern Ireland", flag: "🇬🇧" },
  { code: "+995", iso3: "GEO", name: "Georgia", flag: "🇬🇪" },
  { code: "+44", iso3: "GGY", name: "Guernsey", flag: "🇬🇬" },
  { code: "+233", iso3: "GHA", name: "Ghana", flag: "🇬🇭" },
  { code: "+350", iso3: "GIB", name: "Gibraltar", flag: "🇬🇮" },
  { code: "+224", iso3: "GIN", name: "Guinea", flag: "🇬🇳" },
  { code: "+590", iso3: "GLP", name: "Guadeloupe", flag: "🇬🇵" },
  { code: "+220", iso3: "GMB", name: "Gambia", flag: "🇬🇲" },
  { code: "+245", iso3: "GNB", name: "Guinea-Bissau", flag: "🇬🇼" },
  { code: "+240", iso3: "GNQ", name: "Equatorial Guinea", flag: "🇬🇶" },
  { code: "+30", iso3: "GRC", name: "Greece", flag: "🇬🇷" },
  { code: "+1-473", iso3: "GRD", name: "Grenada", flag: "🇬🇩" },
  { code: "+299", iso3: "GRL", name: "Greenland", flag: "🇬🇱" },
  { code: "+502", iso3: "GTM", name: "Guatemala", flag: "🇬🇹" },
  { code: "+594", iso3: "GUF", name: "Guiana Perancis", flag: "🇬🇫" },
  { code: "+1-671", iso3: "GUM", name: "Guam", flag: "🇬🇺" },
  { code: "+592", iso3: "GUY", name: "Guyana", flag: "🇬🇾" },
  { code: "+852", iso3: "HKG", name: "Hong Kong", flag: "🇭🇰" },
  { code: "+672", iso3: "HMD", name: "Kepulauan Heard & McDonald", flag: "🇭🇲" },
  { code: "+504", iso3: "HND", name: "Honduras", flag: "🇭🇳" },
  { code: "+385", iso3: "HRV", name: "Croatia", flag: "🇭🇷" },
  { code: "+509", iso3: "HTI", name: "Haiti", flag: "🇭🇹" },
  { code: "+36", iso3: "HUN", name: "Hungary", flag: "🇭🇺" },
  { code: "+62", iso3: "IDN", name: "Indonesia", flag: "🇮🇩" },
  { code: "+44", iso3: "IMN", name: "Isle of Man", flag: "🇮🇲" },
  { code: "+91", iso3: "IND", name: "India", flag: "🇮🇳" },
  { code: "+246", iso3: "IOT", name: "Wilayah Lautan Hindi British", flag: "🇮🇴" },
  { code: "+353", iso3: "IRL", name: "Ireland", flag: "🇮🇪" },
  { code: "+98", iso3: "IRN", name: "Iran (Islamic Republic of)", flag: "🇮🇷" },
  { code: "+964", iso3: "IRQ", name: "Iraq", flag: "🇮🇶" },
  { code: "+354", iso3: "ISL", name: "Iceland", flag: "🇮🇸" },
  { code: "+972", iso3: "ISR", name: "Israel", flag: "🇮🇱" },
  { code: "+39", iso3: "ITA", name: "Italy", flag: "🇮🇹" },
  { code: "+1-876", iso3: "JAM", name: "Jamaica", flag: "🇯🇲" },
  { code: "+44", iso3: "JEY", name: "Jersey", flag: "🇯🇪" },
  { code: "+962", iso3: "JOR", name: "Jordan", flag: "🇯🇴" },
  { code: "+81", iso3: "JPN", name: "Japan", flag: "🇯🇵" },
  { code: "+7", iso3: "KAZ", name: "Kazakhstan", flag: "🇰🇿" },
  { code: "+254", iso3: "KEN", name: "Kenya", flag: "🇰🇪" },
  { code: "+996", iso3: "KGZ", name: "Kyrgyzstan", flag: "🇰🇬" },
  { code: "+855", iso3: "KHM", name: "Cambodia", flag: "🇰🇭" },
  { code: "+686", iso3: "KIR", name: "Kiribati", flag: "🇰🇮" },
  { code: "+1-869", iso3: "KNA", name: "Saint Kitts and Nevis", flag: "🇰🇳" },
  { code: "+82", iso3: "KOR", name: "Republic of Korea", flag: "🇰🇷" },
  { code: "+965", iso3: "KWT", name: "Kuwait", flag: "🇰🇼" },
  { code: "+856", iso3: "LAO", name: "Lao People's Democratic Republic", flag: "🇱🇦" },
  { code: "+961", iso3: "LBN", name: "Lebanon", flag: "🇱🇧" },
  { code: "+231", iso3: "LBR", name: "Liberia", flag: "🇱🇷" },
  { code: "+218", iso3: "LBY", name: "Libya", flag: "🇱🇾" },
  { code: "+1-758", iso3: "LCA", name: "Saint Lucia", flag: "🇱🇨" },
  { code: "+423", iso3: "LIE", name: "Liechtenstein", flag: "🇱🇮" },
  { code: "+94", iso3: "LKA", name: "Sri Lanka", flag: "🇱🇰" },
  { code: "+266", iso3: "LSO", name: "Lesotho", flag: "🇱🇸" },
  { code: "+370", iso3: "LTU", name: "Lithuania", flag: "🇱🇹" },
  { code: "+352", iso3: "LUX", name: "Luxembourg", flag: "🇱🇺" },
  { code: "+371", iso3: "LVA", name: "Latvia", flag: "🇱🇻" },
  { code: "+853", iso3: "MAC", name: "Macau", flag: "🇲🇴" },
  { code: "+590", iso3: "MAF", name: "Saint Martin", flag: "🇲🇫" },
  { code: "+212", iso3: "MAR", name: "Morocco", flag: "🇲🇦" },
  { code: "+377", iso3: "MCO", name: "Monaco", flag: "🇲🇨" },
  { code: "+373", iso3: "MDA", name: "Republic of Moldova", flag: "🇲🇩" },
  { code: "+261", iso3: "MDG", name: "Madagascar", flag: "🇲🇬" },
  { code: "+960", iso3: "MDV", name: "Maldives", flag: "🇲🇻" },
  { code: "+52", iso3: "MEX", name: "Mexico", flag: "🇲🇽" },
  { code: "+692", iso3: "MHL", name: "Marshall Islands", flag: "🇲🇭" },
  { code: "+389", iso3: "MKD", name: "North Macedonia", flag: "🇲🇰" },
  { code: "+223", iso3: "MLI", name: "Mali", flag: "🇲🇱" },
  { code: "+356", iso3: "MLT", name: "Malta", flag: "🇲🇹" },
  { code: "+95", iso3: "MMR", name: "Myanmar", flag: "🇲🇲" },
  { code: "+382", iso3: "MNE", name: "Montenegro", flag: "🇲🇪" },
  { code: "+976", iso3: "MNG", name: "Mongolia", flag: "🇲🇳" },
  { code: "+1-670", iso3: "MNP", name: "Kepulauan Mariana Utara", flag: "🇲🇵" },
  { code: "+258", iso3: "MOZ", name: "Mozambique", flag: "🇲🇿" },
  { code: "+222", iso3: "MRT", name: "Mauritania", flag: "🇲🇷" },
  { code: "+1-664", iso3: "MSR", name: "Montserrat", flag: "🇲🇸" },
  { code: "+596", iso3: "MTQ", name: "Martinique", flag: "🇲🇶" },
  { code: "+230", iso3: "MUS", name: "Mauritius", flag: "🇲🇺" },
  { code: "+265", iso3: "MWI", name: "Malawi", flag: "🇲🇼" },
  { code: "+60", iso3: "MYS", name: "Malaysia", flag: "🇲🇾" },
  { code: "+262", iso3: "MYT", name: "Mayotte", flag: "🇾🇹" },
  { code: "+264", iso3: "NAM", name: "Namibia", flag: "🇳🇦" },
  { code: "+687", iso3: "NCL", name: "New Caledonia", flag: "🇳🇨" },
  { code: "+227", iso3: "NER", name: "Niger", flag: "🇳🇪" },
  { code: "+672", iso3: "NFK", name: "Pulau Norfolk", flag: "🇳🇫" },
  { code: "+234", iso3: "NGA", name: "Nigeria", flag: "🇳🇬" },
  { code: "+505", iso3: "NIC", name: "Nicaragua", flag: "🇳🇮" },
  { code: "+683", iso3: "NIU", name: "Niue **", flag: "🇳🇺" },
  { code: "+31", iso3: "NLD", name: "Netherlands", flag: "🇳🇱" },
  { code: "+47", iso3: "NOR", name: "Norway", flag: "🇳🇴" },
  { code: "+977", iso3: "NPL", name: "Nepal", flag: "🇳🇵" },
  { code: "+674", iso3: "NRU", name: "Nauru", flag: "🇳🇷" },
  { code: "+64", iso3: "NZL", name: "New Zealand", flag: "🇳🇿" },
  { code: "+968", iso3: "OMN", name: "Oman", flag: "🇴🇲" },
  { code: "+92", iso3: "PAK", name: "Pakistan", flag: "🇵🇰" },
  { code: "+507", iso3: "PAN", name: "Panama", flag: "🇵🇦" },
  { code: "+870", iso3: "PCN", name: "Kepulauan Pitcairn", flag: "🇵🇳" },
  { code: "+51", iso3: "PER", name: "Peru", flag: "🇵🇪" },
  { code: "+63", iso3: "PHL", name: "Philippines", flag: "🇵🇭" },
  { code: "+680", iso3: "PLW", name: "Palau", flag: "🇵🇼" },
  { code: "+675", iso3: "PNG", name: "Papua New Guinea", flag: "🇵🇬" },
  { code: "+48", iso3: "POL", name: "Poland", flag: "🇵🇱" },
  { code: "+1", iso3: "PRI", name: "Puerto Rico", flag: "🇵🇷" },
  { code: "+850", iso3: "PRK", name: "Democratic People's Republic of Korea", flag: "🇰🇵" },
  { code: "+351", iso3: "PRT", name: "Portugal", flag: "🇵🇹" },
  { code: "+595", iso3: "PRY", name: "Paraguay", flag: "🇵🇾" },
  { code: "+970", iso3: "PSE", name: "State of Palestine (the) *", flag: "🇵🇸" },
  { code: "+689", iso3: "PYF", name: "Polinesia Perancis", flag: "🇵🇫" },
  { code: "+974", iso3: "QAT", name: "Qatar", flag: "🇶🇦" },
  { code: "+262", iso3: "REU", name: "Reunion", flag: "🇷🇪" },
  { code: "+40", iso3: "ROU", name: "Romania", flag: "🇷🇴" },
  { code: "+7", iso3: "RUS", name: "Russian Federation", flag: "🇷🇺" },
  { code: "+250", iso3: "RWA", name: "Rwanda", flag: "🇷🇼" },
  { code: "+966", iso3: "SAU", name: "Saudi Arabia", flag: "🇸🇦" },
  { code: "+249", iso3: "SDN", name: "Sudan", flag: "🇸🇩" },
  { code: "+221", iso3: "SEN", name: "Senegal", flag: "🇸🇳" },
  { code: "+65", iso3: "SGP", name: "Singapore", flag: "🇸🇬" },
  { code: "+500", iso3: "SGS", name: "Kepulauan Georgia Selatan & Sandwich Selatan", flag: "🇬🇸" },
  { code: "+290n", iso3: "SHN", name: "Saint Helena", flag: "🇸🇭" },
  { code: "+47", iso3: "SJM", name: "Svalbard dan Jan Mayen", flag: "🇸🇯" },
  { code: "+677", iso3: "SLB", name: "Solomon Islands", flag: "🇸🇧" },
  { code: "+232", iso3: "SLE", name: "Sierra Leone", flag: "🇸🇱" },
  { code: "+503", iso3: "SLV", name: "El Salvador", flag: "🇸🇻" },
  { code: "+378", iso3: "SMR", name: "San Marino", flag: "🇸🇲" },
  { code: "+252", iso3: "SOM", name: "Somalia", flag: "🇸🇴" },
  { code: "+508", iso3: "SPM", name: "Saint Pierre dan Miquelon", flag: "🇵🇲" },
  { code: "+381p", iso3: "SRB", name: "Serbia", flag: "🇷🇸" },
  { code: "+211", iso3: "SSD", name: "South Sudan", flag: "🇸🇸" },
  { code: "+239", iso3: "STP", name: "Sao Tome and Principe", flag: "🇸🇹" },
  { code: "+597", iso3: "SUR", name: "Suriname", flag: "🇸🇷" },
  { code: "+421", iso3: "SVK", name: "Slovakia", flag: "🇸🇰" },
  { code: "+386", iso3: "SVN", name: "Slovenia", flag: "🇸🇮" },
  { code: "+46", iso3: "SWE", name: "Sweden", flag: "🇸🇪" },
  { code: "+268", iso3: "SWZ", name: "Eswatini", flag: "🇸🇿" },
  { code: "+1-721", iso3: "SXM", name: "Sint Maarten", flag: "🇸🇽" },
  { code: "+248", iso3: "SYC", name: "Seychelles", flag: "🇸🇨" },
  { code: "+963", iso3: "SYR", name: "Syrian Arab Republic", flag: "🇸🇾" },
  { code: "+1-649", iso3: "TCA", name: "Kepulauan Turks dan Caicos", flag: "🇹🇨" },
  { code: "+235", iso3: "TCD", name: "Chad", flag: "🇹🇩" },
  { code: "+228", iso3: "TGO", name: "Togo", flag: "🇹🇬" },
  { code: "+66", iso3: "THA", name: "Thailand", flag: "🇹🇭" },
  { code: "+992", iso3: "TJK", name: "Tajikistan", flag: "🇹🇯" },
  { code: "+690", iso3: "TKL", name: "Tokelau", flag: "🇹🇰" },
  { code: "+993", iso3: "TKM", name: "Turkmenistan", flag: "🇹🇲" },
  { code: "+670", iso3: "TLS", name: "Timor-Leste", flag: "🇹🇱" },
  { code: "+676", iso3: "TON", name: "Tonga", flag: "🇹🇴" },
  { code: "+1-868", iso3: "TTO", name: "Trinidad and Tobago", flag: "🇹🇹" },
  { code: "+216", iso3: "TUN", name: "Tunisia", flag: "🇹🇳" },
  { code: "+90", iso3: "TUR", name: "Turkey", flag: "🇹🇷" },
  { code: "+688", iso3: "TUV", name: "Tuvalu", flag: "🇹🇻" },
  { code: "+886", iso3: "TWN", name: "Taiwan", flag: "🇹🇼" },
  { code: "+255", iso3: "TZA", name: "United Republic of Tanzania", flag: "🇹🇿" },
  { code: "+256", iso3: "UGA", name: "Uganda", flag: "🇺🇬" },
  { code: "+380", iso3: "UKR", name: "Ukraine", flag: "🇺🇦" },
  { code: "+598", iso3: "URY", name: "Uruguay", flag: "🇺🇾" },
  { code: "+1", iso3: "USA", name: "United States of America", flag: "🇺🇸" },
  { code: "+998", iso3: "UZB", name: "Uzbekistan", flag: "🇺🇿" },
  { code: "+39-06", iso3: "VAT", name: "Holy See (the) *", flag: "🇻🇦" },
  { code: "+1-784", iso3: "VCT", name: "Saint Vincent and the Grenadines", flag: "🇻🇨" },
  { code: "+58", iso3: "VEN", name: "Venezuela (Bolivarian Republic of)", flag: "🇻🇪" },
  { code: "+1-284", iso3: "VGB", name: "Kepulauan Virgin British", flag: "🇻🇬" },
  { code: "+1-340", iso3: "VIR", name: "Kepulauan Virgin A.S.", flag: "🇻🇮" },
  { code: "+84", iso3: "VNM", name: "Viet Nam", flag: "🇻🇳" },
  { code: "+678", iso3: "VUT", name: "Vanuatu", flag: "🇻🇺" },
  { code: "+681", iso3: "WLF", name: "Wallis dan Futuna", flag: "🇼🇫" },
  { code: "+685", iso3: "WSM", name: "Samoa", flag: "🇼🇸" },
  { code: "+967", iso3: "YEM", name: "Yemen", flag: "🇾🇪" },
  { code: "+27", iso3: "ZAF", name: "South Africa", flag: "🇿🇦" },
  { code: "+260", iso3: "ZMB", name: "Zambia", flag: "🇿🇲" },
  { code: "+263", iso3: "ZWE", name: "Zimbabwe", flag: "🇿🇼" },
];

export const DEFAULT_PHONE_CODE = "+971";

export function getPhoneCodeByCode(code: string): PhoneCode | undefined {
  return PHONE_CODES.find((p) => p.code === code);
}
